export default "__VITE_ASSET__DCNJZzdD__"